module.exports = __webpack_public_path__ + "assets/img-placeholder.fb1a6f0b.svg";